module.exports = __webpack_public_path__ + "img/playstore.cce2ab38.png";